var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.serviceAccountLink)?_c('nuxt-link',{attrs:{"to":_vm.serviceAccountLink}},[_vm._v("\n  "+_vm._s(_vm.typeDisplay)+"\n")]):_c('div',[_vm._v("\n  "+_vm._s(_vm.typeDisplay)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }